// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3ngqy","fileBtn":"File_fileBtn__3q5J2","closeBtn":"File_closeBtn__1ID6k","fileSelected":"File_fileSelected__1Xmuc","disabled":"File_disabled__3LuII"};